<template>
  <div class="checkout-layout">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'checkout-layout'
}
</script>

<style lang="scss" scoped>
.checkout-layout {
  @media (map_get($breakpoints, sm)) {
    padding: 0 4rem;
  }

  @media (map_get($breakpoints, md)) {
    padding: 0 11rem;
  }

  @media (map_get($breakpoints, lg)) {
    padding: 0 13rem;
  }

  @media (map_get($breakpoints, lg)) {
    margin: 0 auto;
    max-width: 108rem;
  }
}
</style>
